import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator"; // @ts-check

import React, { useEffect } from 'react';
import { Grid, Box } from '@material-ui/core';
import AnalyticsDashboard from '../../../../lab/AnalyticsDashboard';
import ImdbStatus from './ImdbStatus';
import { useDesignImdbState, useDesignImdbDispatch, loadImdb } from './designImdbContext';

var DashboardPreview = function DashboardPreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      content = _ref.content,
      widgetId = _ref.widgetId,
      edmPath = _ref.edmPath,
      onLoad = _ref.onLoad;
  var designImdbState = useDesignImdbState();
  var designImdbDispatch = useDesignImdbDispatch();
  useEffect(function () {
    var asyncEffect =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadImdb(designImdbDispatch, workspace, edmPath);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function asyncEffect() {
        return _ref2.apply(this, arguments);
      };
    }();

    asyncEffect();
  }, [edmPath]);
  return React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(ImdbStatus, {
    stage: designImdbState.stage,
    lastModified: designImdbState.lastModified,
    error: designImdbState.error
  })), designImdbState.path && React.createElement(Grid, {
    item: true,
    container: true,
    justify: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Box, {
    mt: 5
  }, React.createElement(AnalyticsDashboard, {
    width: 600,
    height: 600,
    workspace: workspace,
    path: path,
    content: content,
    imdbPath: designImdbState.path,
    widgetId: widgetId,
    onLoad: onLoad
  })))));
};

export default DashboardPreview;